import { render, staticRenderFns } from "./SetUpGameVillage.vue?vue&type=template&id=fd172e7a&scoped=true"
import script from "./SetUpGameVillage.vue?vue&type=script&lang=ts"
export * from "./SetUpGameVillage.vue?vue&type=script&lang=ts"
import style0 from "./SetUpGameVillage.vue?vue&type=style&index=0&id=fd172e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd172e7a",
  null
  
)

export default component.exports